import { TripProviderContact } from '../../lib/types/models/trip-provider/trip-provider-contact'
import { TripProviderContactInput } from '../../lib/types/models/trip-provider/trip-provider-contact-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createTripProviderContact(
  data: TripProviderContactInput & { tripProviderId: number }
) {
  const { tripProviderId, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.tripProviders.createContact.url, { id: tripProviderId }))
    .post<TripProviderContact, TripProviderContactInput>(rest)
}
